import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "date-filter",
  template: `
    <div class="adc-d-flex adc-flex-column adc-align-items-center adc-position-relative adc-ml8 adc-mr8" (click)="$event.stopPropagation()">
        <div>
            <label>From</label>    
            <input type="date" [(ngModel)]="startDate" class="" placeholder="From.." />
        </div>
        <div>
            <label>To</label>  
            <input type="date" [(ngModel)]="endDate" class="" placeholder="To.." (change)="searchFilter($event)" />
        </div>
    </div>`, 
    standalone: false
})
export class DateFilterComponent {
    @Input() columnName: string = '';
    @Output() searchFilterVal = new EventEmitter();
    startDate: any;
    endDate: any;
    selectedFilter: number = 1;
    filterArr: any = [
        {
            id: 1,
            label: "Contains",
        },
    ];

    clearFilter() {
        this.startDate = '';
        this.endDate = '';
        this.selectedFilter = 1;
    }

    searchFilter(e: Event) {
        this.searchFilterVal.emit({
        startDate: this.startDate,
        endDate: this.endDate,
        selectedFilter: this.selectedFilter,
        });
    }
}
